/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_edit': {
    width: 511.995,
    height: 511.995,
    viewBox: '0 0 511.995 511.995',
    data: '<path pid="0" d="M497.941 14.057c18.75 18.75 18.719 49.141 0 67.891l-22.625 22.625-67.906-67.891 22.625-22.625c18.749-18.734 49.156-18.75 67.906 0zM158.534 285.588l-22.609 90.5 90.5-22.625 226.266-226.266-67.906-67.891-226.251 226.282zm225.469-44.438v206.844h-320v-320h206.859l63.983-64H.003v448h448v-334.86l-64 64.016z"/>'
  }
})
